import { render } from "./Vote.vue?vue&type=template&id=651c063c&scoped=true&ts=true"
import script from "./Vote.vue?vue&type=script&lang=ts"
export * from "./Vote.vue?vue&type=script&lang=ts"

import "./Vote.vue?vue&type=style&index=0&id=651c063c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src903112286/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651c063c"]])

export default __exports__